export default "__VITE_ASSET__DAN5b23v__"